import React, {Component} from 'react';
import {Link} from 'react-router-dom';

class AdminTabs extends Component {
    render(){
        const tabs = [
            {uri: 'tickets', title: 'Tickets'},
            {uri: 'instructors', title: 'Instructors Performance'},
            {uri: 'flagged-comments', title: 'Flagged Comments'},
            {uri: 'announcements', title: 'Announcements'},
            {uri: 'view-as', title: 'View As', hide: true},
            {uri: 'attachments', title: 'Attachments'},
            {uri: 'notes', title: 'Notes', hide: true},
            {uri: 'faqs', title: 'FAQs', hide: true},
            {uri: 'settings', title: 'Settings'},
            ]
        return (
            <div className="chat-head no-padding">
                    <div className="">
                        <ul className="header-nav">
                        
                            {tabs.map(t => {
                                return (
                                    <li className={`${(this.props.view === t.uri) ? 'active' : ''} ${t.hide ? 'text-danger' : ''}`}><Link className={t.hide ? 'disabled' : ''} to={`/chat/admin/${t.uri}`}>{t.title}</Link></li>
                                )
                            })
                            }
                            
                        </ul>
                    </div>
                </div>
            )
    }
}

export default AdminTabs;


// WEBPACK FOOTER //
// ./src/components/Chat/AdminTabs.js